if (!customElements.get('faq-links')) {
  class FaqLinks extends HTMLElement {
    constructor() {
      super();
      const urlParams = new URLSearchParams(window.location.search);
      const faqId = urlParams.get('faq');

      // Check if the 'faq' parameter exists
      if (faqId) {
        const collapsibleElement = document.querySelector(`[data-faq-id="${faqId}"]`);

        if (collapsibleElement) {
          collapsibleElement.classList.add('collapsible-is-open');

          collapsibleElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }
    }
  }

  window.FaqLinks = FaqLinks;

  customElements.define('faq-links', FaqLinks);
}
